import { AxiosError, AxiosResponse } from "axios";
import http from "./http";

export function uploadImage(companyId: string, toiletId: string, file: { file: Blob; name: string }): Promise<void> {
    const data: FormData = new FormData();
    data.append("image", file.file, file.name);
    return http
        .post(`/v1/companies/${companyId}/toilets/${toiletId}/images`, data)
        .then((response: AxiosResponse) => response.data)
        .catch((error: AxiosError) =>
            Promise.reject(error.response ? error.response.data : { message: "connection error", name: "" }),
        );
}

export function deleteImage(companyId: string, toiletId: string): Promise<void> {
    return http
        .delete(`/v1/companies/${companyId}/toilets/${toiletId}/images`)
        .then((response: AxiosResponse) => response.data)
        .catch((error: AxiosError) =>
            Promise.reject(error.response ? error.response.data : { message: "connection error", name: "" }),
        );
}
